export default {"src":"/_next/static/media/favicon.007bd29c.svg","height":1499,"width":1485,"blurWidth":0,"blurHeight":0};